export default "__VITE_ASSET__C0C9JxQq__"